import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/front/category-showcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/front/featured-products.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/heros/cinematic-hero.tsx");
